import { Box, Divider } from "@material-ui/core";
import { withStyles } from "@material-ui/core/styles";

import {
  Dashboard,
  ExitToApp,
  KeyboardArrowLeft,
  KeyboardArrowRight,
  LibraryBooks,
  List,
  SupervisorAccount,
  Timeline,
  WbSunny,
  // Replay,
  VpnKey,
  HelpSharp,
  LocationCity,
  MonetizationOn ,

} from "@material-ui/icons";
import CustomCloseButton from './CustomCloseButton';
// import DirectionsWalkIcon from '@material-ui/icons/DirectionsWalk'; // Example icon for "Tour"

// import TicketIcon from '@material-ui/icons/ConfirmationNumber';
import React from "react";
import { Link } from "react-router-dom";
import { GritLogo } from "src/assets/GritLogo";
// import Subscription from "src/assets/subscription.png";
import Component from "src/shared/components/Component";
import SidebarLink from "src/shared/components/sidebar/components/SidebarLink/SidebarLink";
import withAxios from "src/shared/components/withAxios";
import { IEvaluationRequest, ISport, ISurveyResponse, IStartTourRequest, IUser } from "src/api/types";
import { withSchoolContext } from "../../DirectorPage";
import SendEvalModal from "../SendEvalModal";
import {
  ADMINISTRATORS,
  CLOSE_MENU,
  DASHBOARD,
  DATA_CENTER,
  // HELP_CENTER,
  OPEN_MENU,
  RESOURCES,
  SCHOOL,
  SEASONS,
  SIGN_OUT,
  SURVEYS,
  CHANGE_PASS
} from "./constants";
import { styles } from "./styles";
import { IProps, ISidebarNavigationState } from "./types";
import Joyride, { STATUS } from 'react-joyride';
// import SupportIcon from "src/shared/components/SupportIcon";
// import { ZENDDESK_FAQ } from "src/constants";
import { checkUserStatusAndRedirect } from "src/api/types/commonLogout";
// import HistoryIcon from '@material-ui/icons/History';
import DescriptionIcon from "@material-ui/icons/Description";
// import CustomTooltip from "src/shared/components/CustomTooltip";
export const DirectorSidebar = withSchoolContext(
  withStyles(styles)(
    withAxios(
      class SidebarClass extends Component<IProps, ISidebarNavigationState> {
        // private joyrideRef: RefObject<Joyride> = createRef(); // Create a ref for Joyride

        constructor(props: IProps) {
          super(props);
          console.log("this prop", this.props)
          this.state = {
            modalVisible: false,
            isMeadSeason: false,
            isJvCoach: "",
            run: false,
            stepIndex: 0,
            steps: [
              {
                target: '.home-link',
                // title: 'WELCOME',
                placement: 'center',
                content: this.AppRender(`Hello, Welcome to your school's personalized dashboard. From here, you can add coaches, manage data, and print results!`, false),
              },
              {
                target: '.menuButton',
                // title: 'MENU',
                content: this.AppRender("Click here to expand your menu bar."),
              },
              {
                target: '.dashboard-link',
                // title: 'CONGRATULATIONS',
                content: this.AppRender('Clicking the dashboard button will always get you back home. It is where you can add and update coaches as well as manage your surveys.', false),
              },
              {
                target: '.data-center-link',
                // title: 'DATA CENTER',
                content: this.AppRender(`View all available data in the system by clicking here.`),
              },
              {
                target: '.school-settting-link',
                // title: 'SCHOOL SETTINGS',
                content: this.AppRender(`Start by clicking on the school icon to update your school’s colors, logo, and other important information. Updating the logo will personalize the reports for your school.`),
              },
              {
                target: '.manage-subscription',
                // title: 'MANAGE SUBSCRIPTION',
                // placement: 'center',
                content: this.AppRender('Here, you can view and upgrade your subscription, add features, update payment details, and generate invoices.'),
              },
              // {
              //   target: '.helpcenter-link',
              //   // title: 'HELP CENTER',
              //   content: this.AppRender(`For FAQs, video tutorials, or the ability to submit a question, click here.`),
              // },
              {
                target: '.serveyButton',
                // title: 'SURVEYS',
                content: this.AppRender(`Access your school’s pre-loaded survey template by clicking here. You will also be able to add, edit, or delete the questions that are loaded for your school.`),
              },
              {
                target: '.seasonsButton',
                // title: 'SEASONS',
                content: this.AppRender("Ensure your sports are categorized in the correct season for your state by selecting the sport and assigning the appropriate season."),
              },
              {
                target: '.administratorsButton',
                // title: 'ADMINISTRATORS',
                content: this.AppRender("Add other Athletic Department staff to assist in managing surveys. We recommend adding assistant ADs and athletic office administrators."),
              },
              {
                target: '.resourceButton',
                // title: 'RESOURCES',
                content: this.AppRender("Visit the learning center for helpful articles, videos, podcasts, and other materials to support the leadership of your coaches."),
              },
              {
                target: '.logout-link',
                // title: 'LOG OUT',
                content: this.AppRender("Click here to log out when you're finished using the platform."),
              },
              {
                target: '.coach-add',
                // title: 'ADDING COACHES',
                // placement: 'center',
                content: this.AppRender('Let’s get started! Please take a moment to add a coach by clicking here. Select their sport, then click “ADD NEW COACH” to proceed.', true),
              },


            ],
            newrun: false,
            newstepIndex: 0,
            user: {},
            previousIndex: 0,
            newsteps: [
              {
                target: '.coach-add',
                // title: 'ADDING COACHES',
                placement: 'center',
                content: this.AppRender('Let’s get started! Please take a moment to add a coach by clicking here. Select their sport, then click “ADD NEW COACH” to proceed.'),
              },
              {
                target: '.teamEvaluation',
                // title: 'TEAM EVALUATION LINK',
                content: this.AppRender("Here you can access the links if you need to resend a link to a team, a coach, or a parent."),
              },

              {
                target: '.evaluationHistory',
                // title: 'EVALUATION HISTORY',
                content: this.AppRender('This is where your surveys will be stored over time. An online filing cabinet for each coach.'),
              },
              {
                target: '.numbers',
                // title: 'NUMBERS',
                content: this.AppRender("This is the live tab of your response counts for each survey."),
              },

              {
                target: '.startEvaluation',
                // title: 'START EVALUATIONS',
                content: this.AppRender('The Start Survey button allows you to officially generate a link that we can send to students, to the coach, or to parents. Click the button to see!'),
              },
              {
                target: '.cancelbutton',
                // title: 'CANCEL',
                content: this.AppRender("This button allows you to cancel and delete an survey you didn't mean to start. Just push the Cancel button and the system will delete only that survey and its data (if any). Click outside the box to continue."),
              },
              {
                target: '.stopButton',
                // title: 'STOP EVALUATIONS',
                content: this.AppRender(`Pushing this button allows you to STOP accepting responses. You may restart accepting responses again by pushing REOPEN PREVIOUS SURVEYS.`),
              },
              {
                target: ".sendEvaluation",
                // title: 'SEND EVALUATIONS BOX',
                content: this.AppRender("All you do is copy the link and build an email or QR code for the link so students have access to the link to give their opinions. Do the same for your coach. If you choose to engage parents, you can copy and send that link as well. click outside the pop up box to continue."),
              },



              {
                target: '.viewButton',
                // title: 'VIEW',
                content: this.AppRender('If you are ready to prepare the report just click VIEW DATA and go through the form and prepare all the data for your coach. Once you are viewing the data, you have the option to PRINT or save as a PDF. If you are done with your surveys it should be mark the survey "COMPLETED".'),
              },

              {
                target: '.startNewEvaluation',
                // title: 'START NEW EVALUATION',
                content: this.AppRender('This button is to be used when you are ready to start a brand new survey process for a coach the following year or for a second time in a given season. pushing START NEW SURVEYS will archive the previous survey into the SURVEY HISTORY and start a brand new survey for you to send out. '),
              },
              {
                target: '.start-tour',
                // title: 'CONGRATULATIONS!',
                // placement: 'center',
                content: this.AppRender("You have now completed a basic run through of how to manage creating a coach, sending, receiving, and viewing data, and preparing the report for a coach.  Go explore and send your first survey to a team and a coach! You can restart the tour at any time by clicking here."),
              },
            ],
          };

          console.log("isSidebarOpen===========>")
        }
        // public checkActiveClass=(mainClass:any,bodyClass:any)=>{
        //   let element:any = document.querySelector(mainClass);

        // // Check if it has the 'active' class
        // if (element.classList.contains('active')) {
        //    return mainClass
        // } else {
        //   return bodyClass
        // }
        // }
         
        public componentDidMount = async () => {
          // checkUserStatusAndRedirect();
          // const data =
          // {
          //   userId: this?.state?.user?.id,
          //   schoolId: this.props.school.id,
            
          // }
          // 535
         
          // director.id
          const res: any = await this.buildGet<IUser>(this, "user")()
          console.log("USERRESPO=====>", res)
          const firstName = res?.firstName ? res.firstName : 'User';
          console.log("First Name:", firstName);
          const hhheadcoch =  await this.buildPost<{userId:any, schoolId:any}, any>(
            this,
            "/coaches/getHeadCoach"
          )({
            userId: res?.id,
            schoolId: this.props.school.id,
            
          });
          console.log("Selected headcoach:::", hhheadcoch, hhheadcoch?.data?.type)
          if(hhheadcoch?.data?.type === "head" && hhheadcoch?.data !== null){
          this.setState({ isMeadSeason: true})
          }else if (hhheadcoch?.data?.type === "coach" && hhheadcoch?.data !== null){
          this.setState({ isJvCoach: true})
          }else{
            this.setState({ isJvCoach: false, isMeadSeason: false})
          }
          // Update state with the retrieved firstName and dynamically update step content
          // this.setState(prevState => ({
          //   steps: prevState.steps.map((step: any) => {
          //     if (step.target === '.home-link') {
          //       return {
          //         ...step,
          //         content: this.AppRender(
          //           `Hello, ${firstName}! Welcome to your school's personalized dashboard. From here, you can add coaches, manage data, and print results!`,
          //           false
          //         ),
          //       };
          //     }
          //     return step;
          //   }),
          // }));
          this.setState({ user: res, run: this.state.isMeadSeason === false &&
            this.state.isJvCoach === false &&
             res?.videoCount > 3 ? false : this.getBooleanValue("showtour") })
          localStorage.setItem("showtour", JSON.stringify(false));
          console.log(
            "ismeadseson:", this.state.isMeadSeason, 
            "isjv", this.state.isJvCoach,
            "videoCount:", res?.videoCount, 
            "run value:", this.state.isMeadSeason === false && res?.videoCount > 3 
                         ? false 
                         : this.getBooleanValue("showtour")
          );
          
        }
        public getBooleanValue = (key: any) => {
          const value = localStorage.getItem(key);
          return value ? JSON.parse(value) : false; // Default to false if not found
        };
        public AppRender = (title: string = "", continueTour = false) => {
          return (
            <div style={{ marginTop: "15px" }}>
              {/* <img src="https://images.pexels.com/photos/414612/pexels-photo-414612.jpeg?auto=compress&cs=tinysrgb&w=800" alt="Example" style={imageStyle} /> */}
              <p style={{ marginBottom: "0px" }}>{title}</p>
              {continueTour && <button onClick={() => {
                this.setState({ run: false, newrun: true })

              }} style={{
                backgroundColor: '#494b8f',
                color: '#ffffff',
                padding: '8px 12px', marginTop: 10
              }}>Continute Tour</button>}
              <CustomCloseButton onClose={() => this.setState({ run: false })} />
            </div>
          );
        }

        public handleStartTour = async () => {
          this.setState({ run: true })
          // this.getUserAPI()
          this.callTourAPIIntegration(true)
        }
        public handleJoyrideCallback = (data: any) => {
          const { status, index, type } = data;
          console.log("TOUR_TYPE_INDEX", index, type)

          if ([STATUS.FINISHED, STATUS.SKIPPED].includes(status)) {
            this.setState({ run: false })
          }
          if ([STATUS.FINISHED].includes(status)) {
            this.callTourAPIIntegration(false)
          }
          this.setState({ stepIndex: index + 1 });
        };
        public newhandleJoyrideCallback = (data: any) => {
          const { status, index, type } = data;
          console.log("TOUR_TYPE_INDEX", index, type)

          if ([STATUS.FINISHED, STATUS.SKIPPED].includes(status)) {
            this.setState({ newrun: false })
          }
          if ([STATUS.FINISHED].includes(status)) {
            this.callTourAPIIntegration(false)
          }
          this.setState({ newstepIndex: index + 1 });
        };
        public callTourAPIIntegration = async (status = false) => {
          if (this?.state?.user?.id) {
            const res = await this.buildPut<IStartTourRequest, {}>(
              this,
              `user/restartTour`
            )({
              "userId": this?.state?.user?.id,
              "restartTour": status
            });
            console.log("START TOUR RESPONSE==========>", this?.state?.user?.id, res)
          }
        }

        public render() {
          const { modalVisible, surveyResponse, startEvaluationSubmitting, isMeadSeason , isJvCoach} =
            this.state;

          const { classes, isSidebarOpen, toggleIsSidebarOpen, school } =
            this.props;

          return (
            <Box className={classes.sidebar}                 style={{
              // maxHeight: "calc(100vh - 153px)",
              overflowY: "auto",
              scrollbarWidth: 'none',          // Firefox
msOverflowStyle: 'none',         // IE 10+
WebkitOverflowScrolling: 'touch',
            }}>
              <Box className={classes.sidebarBackground}>
                <SendEvalModal
                  open={modalVisible}
                  closeModal={this.closeModal}
                  startEvaluation={this.startEvaluation}
                  surveyResponse={surveyResponse}
                  resetState={this.resetState}
                  startEvaluationSubmitting={startEvaluationSubmitting}
                  route={`/${this.props.school.slug}/upgrade-subscription`}
                  // history={this.props.history}
                />
                {isMeadSeason === false && isJvCoach === false && <>
                <Joyride
                  callback={this.handleJoyrideCallback}
                  continuous={true}
                  run={this.state.run}
                  scrollToFirstStep={false}
                  showProgress={false}
                  showSkipButton={true}
                  steps={this.state.steps}
                  styles={{
                    options: {
                      zIndex: 10000,
                    },
                    buttonClose: {
                      color: '#000000',
                      display: 'none'

                    },
                    buttonBack: {
                      color: '#000000',
                    },
                    buttonNext: {
                      backgroundColor: '#494b8f',
                      color: '#ffffff',
                      padding: '8px 12px',
                    },
                  }}
                  locale={{
                    next: 'Next', // Change "Next" button label to "Proceed"
                    back: 'Go Back', // Optional: Change the "Back" button label
                    last: 'Finish',  // Optional: Change the "Last" button label
                    skip: 'Skip Tour', // Optional: Change the "Skip" button label
                    close: 'Close'   // Optional: Change the "Close" button label
                  }}
                />
                <Joyride
                  callback={this.newhandleJoyrideCallback}
                  continuous={true}
                  run={this.state.newrun}
                  scrollToFirstStep={false}
                  showProgress={false}
                  showSkipButton={true}
                  steps={this.state.newsteps}
                  styles={{
                    options: {
                      zIndex: 10000,
                    },
                    buttonClose: {
                      color: '#000000',
                      display: 'none'

                    },
                    buttonBack: {
                      color: '#000000',
                    },
                    buttonNext: {
                      backgroundColor: '#494b8f',
                      color: '#ffffff',
                      padding: '8px 12px',
                    },
                  }}
                  locale={{
                    next: 'Next', // Change "Next" button label to "Proceed"
                    back: 'Go Back', // Optional: Change the "Back" button label
                    last: 'Finish',  // Optional: Change the "Last" button label
                    skip: 'Skip Tour', // Optional: Change the "Skip" button label
                    close: 'Close'   // Optional: Change the "Close" button label
                  }}
                />
                </>}
                <Box
                  className={classes.innerSidebar}
                  display="flex"
                  flexDirection="column"
                  justifyContent="space-between"
                >
                  <Box>
                    <Link to="/" >
                      <div className="home-link">
                        <GritLogo
                          className={classes.gritLogo}
                          isSidebarOpen={isSidebarOpen}
                        />
                      </div>

                    </Link>
                    <Divider className={classes.divider} />
                    <Box display="flex" flexDirection="column" gridGap="1rem" >
                      <div className="dashboard-link">
                        <SidebarLink
                          isSidebarOpen={isSidebarOpen}
                          tooltipTitle={DASHBOARD}
                          icon={<Dashboard />}
                          to={`/${school.slug}/dashboard`}
                          title={DASHBOARD}
                          className="about-link"
                        />
                      </div>
                      
                     

                      {isJvCoach !== true && 
                      <div className="data-center-link">
                        <SidebarLink
                          isSidebarOpen={isSidebarOpen}
                          tooltipTitle={DATA_CENTER}
                          icon={<Timeline />}
                          to={`/${school.slug}/survey-data-center`}
                          title={DATA_CENTER}
                        />
                      </div>
                      }
                      {isMeadSeason === false && isJvCoach === false &&
                      <>
                      <div className="school-settting-link">
                        <SidebarLink
                          isSidebarOpen={isSidebarOpen}
                          tooltipTitle={SCHOOL}
                          icon={<LocationCity />}
                          to={`/${school.slug}/editschooluser`}
                          title={SCHOOL}
                        />                  
                      </div>  

                      

                      {(school as any).ismidseason === false && (school as any).isAdSurvey === false &&
                      <div className="manage-subscription">
                        <SidebarLink
                          isSidebarOpen={isSidebarOpen}
                          tooltipTitle={"Subscription"}
                          icon={<MonetizationOn />}
                          to={`/${school?.slug}/subscription-history`}
                          title={"Subscription"}
                        />
                      </div>
                      }
                      </>
                       }

          {/* {
  console.log("school", school)
}

{
  console.log("this.state", this.state)
}

{
  console.log("this.props", this.props)
} */}


                      {(school as any).ismidseason === false && (school as any).isAdSurvey === false &&
                        <div className="external-links">
                          <SidebarLink
                            isSidebarOpen={isSidebarOpen}
                            tooltipTitle={"Report History"}
                            icon={<DescriptionIcon style={{ color: "#fff" }} />}
                            to={`/${school.slug}/report-history`}
                            title={"Report History"}
                          />
                        </div>
                      }

                     

                      {/* <div className="helpcenter-link">
                        <SidebarLink
                          isSidebarOpen={isSidebarOpen}
                          tooltipTitle={HELP_CENTER}
                          icon={<SupportIcon style={{ color: '#fff' }} />}
                          externalLink={
                            ZENDDESK_FAQ
                          }
                          target="_blank"
                          title={HELP_CENTER}
                        />
                      </div> */}

                    </Box>
                  </Box>
                  <Box>
                    <Divider className={classes.divider} />
                    <Box display="flex" flexDirection="column" gridGap="1rem">
                      <div className="menuButton">
                        <SidebarLink
                          isSidebarOpen={isSidebarOpen}
                          tooltipTitle={isSidebarOpen ? CLOSE_MENU : OPEN_MENU}
                          icon={
                            isSidebarOpen ? (
                              <KeyboardArrowLeft />
                            ) : (
                              <KeyboardArrowRight />
                            )
                          }
                          to=""
                          title="CLOSE MENU"
                          action={() =>
                            toggleIsSidebarOpen((prevState) => !prevState)
                          }
                        />
                      </div>

                      {/* <button onClick={this.handleStartTour}>Start Tour</button> */}
                      <div className="serveyButton">
                        <SidebarLink
                          isSidebarOpen={isSidebarOpen}
                          tooltipTitle={SURVEYS}
                          icon={<List />}
                          to={`/${school.slug}/survey`}
                          title={SURVEYS}
                        />
                      </div>
                      {isMeadSeason === false && isJvCoach === false &&
                      <>
                      <div className="seasonsButton">
                        <SidebarLink
                          isSidebarOpen={isSidebarOpen}
                          tooltipTitle={SEASONS}
                          icon={<WbSunny />}
                          to={`/${school.slug}/seasons`}
                          title={SEASONS}
                        />
                      </div>
                      <div className="administratorsButton">
                        <SidebarLink
                          isSidebarOpen={isSidebarOpen}
                          tooltipTitle={ADMINISTRATORS}
                          icon={<SupervisorAccount />}
                          to={`/${school.slug}/administrators`}
                          title={ADMINISTRATORS}
                        />
                      </div>
                      </>
        }
                      <div className="resourceButton">
                        <SidebarLink
                          isSidebarOpen={isSidebarOpen}
                          tooltipTitle={RESOURCES}
                          icon={<LibraryBooks />}
                          externalLink={
                            "https://www.gritleadershipea.com/learn"
                          }
                          target="_blank"
                          title={RESOURCES}
                        />
                      </div>
                      {isMeadSeason === false && isJvCoach === false && 
                      <div className="start-tour">
                        <SidebarLink
                          isSidebarOpen={isSidebarOpen}
                          tooltipTitle={"START TOUR"}
                          icon={<HelpSharp/>
                          }
                          to=""
                          title="START TOUR"
                          action={() =>{
                            this.handleStartTour()
                            checkUserStatusAndRedirect()
                          }
                          }
                        />
                      </div>
         }
         {this.state?.user?.isAdmin === false &&

         <div className="logout-link">
                        <SidebarLink
                          isSidebarOpen={isSidebarOpen}
                          tooltipTitle={CHANGE_PASS}
                          icon={<VpnKey />}
                          to="/reset/password/new?status=sidebar"
                          title={CHANGE_PASS}
                        />
                      </div>
        }
                      <div className="logout-link">
                        <SidebarLink
                          isSidebarOpen={isSidebarOpen}
                          tooltipTitle={SIGN_OUT}
                          icon={<ExitToApp />}
                          to="/logout"
                          title={SIGN_OUT}
                        />
                      </div>

                    </Box>
                  </Box>
                </Box>
              </Box>
            </Box>
          );
        }

        private readonly openModal = () =>
          this.setState({ modalVisible: true });

        private readonly closeModal = () =>
          this.setState({ modalVisible: false });

        private readonly startEvaluation = (sport: ISport) => {
          this.runCancellableStatefulAsync(
            this,
            {
              startEvaluationSubmitting: true,
            },
            {
              startEvaluationSubmitting: undefined,
            },
            async () => {
              const surveyResponse = await this.buildPost<
                IEvaluationRequest,
                ISurveyResponse
              >(
                this,
                "survey/start"
              )({
                schoolId: this.props.school.id,
                sportId: sport.id,
              });
              this.props.loadSurveys(sport.id);
              // open modal with the links
              this.openModal();
              this.setState({ surveyResponse });
            },
            (ex: any) => {
              console.log("error", ex);
            }
          );
        };

        private readonly resetState = () => {
          this.setState({ surveyResponse: undefined });
        };
      }
    )
  )
);



// WEBPACK FOOTER //
// ./src/features/director/pages/DirectorSidebar/DirectorSidebar.tsx